import { MdPerson } from 'react-icons/md';

type Props = {
  variant: 'user' | 'agent' | 'live-perception';
  agentName?: string;
  agentAvatarUrl?: string | null;
};

export function TranscriptAvatar({ variant, agentName, agentAvatarUrl }: Props) {
  if (variant === 'live-perception') {
    return (
      <div className="avatar lp-debug-avatar" aria-hidden="true">
        LP
      </div>
    );
  }

  if (variant === 'user') {
    return (
      <div className="avatar user-avatar-icon" aria-hidden="true">
        <MdPerson size={30} />
      </div>
    );
  }

  const url = agentAvatarUrl?.trim();
  const initial = (agentName?.[0] || 'A').toUpperCase();

  return (
    <div
      className="avatar agent-avatar"
      aria-hidden="true"
      style={
        url
          ? {
              backgroundImage: `url(${url})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              color: 'transparent',
            }
          : undefined
      }
    >
      {url ? null : initial}
    </div>
  );
}
